const carpayLPNotFoundRoute = '/carpay/orders/lp-not-found'

export default carpayLPNotFoundRoute

export const carpayLPNotFoundLocationSearchRoute = `${carpayLPNotFoundRoute}/search`
export const carpayLPNotFoundStayRoute = `${carpayLPNotFoundRoute}/stay`
export const carpayLPNotFoundOverviewRoute = `${carpayLPNotFoundRoute}/overview`
